import type { AuthResponse, InstallationStatus, MaintenanceJob, SetupDraft } from '../types/index.js'
import { API_BASE_URL, httpRequest } from './http.js'

export interface SetupStatusResponse {
  status: InstallationStatus
  draft: SetupDraft
  currentJobId?: string | null
  error?: string | null
  defaultCategories: Array<{ label: string; active: boolean; sortOrder: number }>
  controllerAvailable: boolean
}

export const setupApi = {
  status: () => httpRequest<SetupStatusResponse>('/setup/status', { cache: 'no-store' }),
  saveDraft: (draft: Partial<SetupDraft>) => httpRequest<SetupStatusResponse>('/setup/draft', { method: 'PATCH', body: JSON.stringify(draft) }),
  probeStorage: (mediaPath: string, templatesPath: string) => httpRequest<MaintenanceJob>('/setup/storage/probe', { method: 'POST', body: JSON.stringify({ mediaPath, templatesPath }) }),
  probePlayout: (targets: SetupDraft['targets'], router: SetupDraft['router']) => httpRequest<MaintenanceJob>('/setup/playout/probe', { method: 'POST', body: JSON.stringify({ targets, router }) }),
  uploadArchive: async (file: File) => {
    const data = new FormData(); data.set('file', file)
    const response = await fetch(`${API_BASE_URL}/setup/imports`, { method: 'POST', body: data, credentials: 'include' })
    if (!response.ok) throw new Error('Import de l’archive impossible.')
    return response.json() as Promise<{ path: string; name: string }>
  },
  uploadLogo: async (file: File) => {
    const data = new FormData(); data.set('file', file)
    const response = await fetch(`${API_BASE_URL}/setup/logo`, { method: 'POST', body: data, credentials: 'include' })
    if (!response.ok) throw new Error('Le PNG est invalide ou dépasse 20 Mio.')
    return response.json() as Promise<{ path: string; width: number; height: number; canvasCompatible: boolean }>
  },
  useArchivePath: (path: string) => httpRequest<{ path: string }>('/setup/imports/from-path', { method: 'POST', body: JSON.stringify({ path }) }),
  verifyArchive: (path: string, passphrase: string) => httpRequest<MaintenanceJob>('/setup/restore/verify', { method: 'POST', body: JSON.stringify({ path, passphrase }) }),
  applyScratch: (body: unknown) => httpRequest<AuthResponse & { channel: { id: string; name: string; slug: string } }>('/setup/scratch/apply', { method: 'POST', body: JSON.stringify(body) }),
  startRestore: (body: unknown) => httpRequest<MaintenanceJob>('/setup/restore/start', { method: 'POST', body: JSON.stringify(body) }),
  activate: (activate = true) => httpRequest<MaintenanceJob | { status: 'READY'; engineActive: false }>('/setup/activation/start', { method: 'POST', body: JSON.stringify({ activate }) }),
  job: (id: string) => httpRequest<MaintenanceJob>(`/setup/jobs/${id}`, { cache: 'no-store' }),
}
